var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-cell',{attrs:{"title":"修改密码","is-link":""},on:{"":function($event){},"click":function($event){return _vm.goTo('/updatePassword')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }